<template>
<div class="tile is-parent is-12 is-vertical" v-if="open">
  <article class="tile is-child box">
    <div class="container is-child" style="margin-top:5px;">
      <h1 class="title has-text-centered">New {{type}}</h1>

      <slot></slot>

    </div>
  </article>
</div>

</template>

<script>
export default {
  props: ['type', 'open'],
  data () {
    return {

    }
  },
  methods: {
    submit () {
      this.$emit('submit')
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {

  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// new-item.vue?2c892866